import {
  useContext, useEffect, useState,
} from 'react';
import { Button } from '@mui/material';
import ImageSelectionList from './ImageSelectionList';
import { ImageItem, ImagesContext } from '../../../contexts/ImagesContext';
import { ImageTypeValue } from '../../../utils/image';
import InputImage from '../../../components/Form/InputImage';
import styles from './ImageSelectionModal.module.css';
import ModalComponent from '../../../components/ModalComponent';

interface Props {
  open: boolean
  handleClose: () => void
  handleSave: (item: ImageItem) => void
}

const Index = (props: Props) => {
  const { open, handleClose, handleSave } = props;
  const { images, GetImages } = useContext(ImagesContext);
  const [selectedImage, setSelectedImage] = useState<ImageItem | null>(null);
  const [imageMaxSizeError, setImageMaxSizeError] = useState<string | null>(null);

  useEffect(() => {
    GetImages(ImageTypeValue.BLOCKS_IMAGE);
  }, [GetImages]);

  const customNavTabs = `nav navTabs ${styles.customNavTabs}`;
  const customTabContent = `tab-content tabContent ${styles.customTabContent}`;

  return (
    <>
      <div
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
        }}
      >
        <ModalComponent
          size="xl"
          title="イメージ画像選択"
          confirmButtonText="選択する"
          onConfirm={() => {
            handleSave(selectedImage);
            setSelectedImage(null);
            setImageMaxSizeError(null);
          }}
          show={open}
          disabled={!selectedImage}
          closeModal={() => {
            setImageMaxSizeError(null);
            handleClose();
          }}
          centered
          animation={false}
          bodyClassName="p-0"
          scrollable
          contentClassName="fullViewportHeight"
        >
          <div className="tab modalTabs">
            <ul className={customNavTabs} role="tablist" style={{ overflow: 'auto' }}>
              <li><a className="active" href="#tabImage_1" data-bs-toggle="tab" role="tab">ブロック画像</a></li>
            </ul>
            <div className={customTabContent}>
              <div id="tabImage_1" className="tab-pane tabPane active">
                <div className="imageUpload">
                  <Button
                    className="btn btn-primary ml-2"
                    variant="contained"
                    component="label"
                    sx={{
                      position: 'relative',
                    }}
                  >
                    <InputImage
                      type={ImageTypeValue.BLOCKS_IMAGE}
                      id="id"
                      isDisabled={false}
                      fileHandler={() => {
                        GetImages(ImageTypeValue.BLOCKS_IMAGE);
                      }}
                      onMaxFileSizeExceeded={(message) => {
                        setImageMaxSizeError(message);
                      }}
                    />
                    画像をアップロードする ...
                  </Button>
                  <span style={{ marginLeft: 5 }}>※このメニューはシステム管理者のみ表示する</span>
                  {imageMaxSizeError && (
                    <div className="text-danger mt-2">
                      {imageMaxSizeError}
                    </div>
                  )}
                </div>
                <ImageSelectionList
                  images={images}
                  handleSelected={(id, url, thumbnail) => {
                    setSelectedImage({
                      id,
                      url,
                      thumbnail,
                    });
                  }}
                />
              </div>
            </div>
          </div>
        </ModalComponent>
      </div>
    </>
  );
};

export default Index;
